import { isInteger } from "lodash";

export const integer =
  (message = "Must be a whole number") =>
  (value: any) =>
    !value || isInteger(value) ? undefined : message;
